<template>
  <div class="side_bar">
    <template v-if="tabList.length>0">
      <div class="tabs">
        <div class="tabs-items" :class="{'active':tabChecked == items.type}" v-for="(items,index) in tabList" :key="index" @click="tabsClick(items.type)">
          <span>{{ items.name }}</span>
        </div>
      </div>

      <el-tabs class="menu_box" v-model="tabChecked">
        <el-tab-pane v-for="(list, key) in trees" :key="key" :name="key">
          <menu-tree :obj="list" :active="active" @treeItemClick="treeItemClick"></menu-tree>
        </el-tab-pane>
      </el-tabs>
    </template>
    <div v-else class="no_data">暂无数据</div>
  </div>
</template>

<script setup>
  import menuTree from './menuTree.vue';
  import { ElTabs, ElTabPane } from 'element-plus';
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  import { getTrees } from '../services/service';
  import { getTreeDefaultActive } from '../utils/tools';

  const emits = defineEmits();
  const store = useStore();
  let tabList = ref([]);
  let tabChecked = ref('');
  let trees = ref({});
  let active = ref(null);

  // ---------------------------------------------
  const tabsClick = (type) => {
    tabChecked.value = type;
    emits('getTabActive', type);
  };

  const setStoreVar = (obj) => {
    const { pd = '', crumbs = '', nodeId = '' } = obj;
    store.dispatch('aSetDtType', pd); // 获取指标的时点类型
    store.dispatch('aSetTargetId', nodeId); // 获取指标对应的ID
    store.dispatch('aSetCrumbs', crumbs); // 获取指标对应的面包屑数据
  };

  const getTreesData = () => {
    getTrees().then((rs) => {
      if (Object.keys(rs).length > 0) {
        const { tabTitles, treeList } = rs;
        tabList.value = tabTitles; // tab 标签页头
        trees.value = treeList; // 菜单树
        tabChecked.value = tabTitles[0]['type']; // tab 默认选中value
        emits('getTabActive', tabChecked.value);
        let defaultTreeData = getTreeDefaultActive(treeList[tabChecked.value]);
        active.value = defaultTreeData['nodeId']; // 菜单树 设置默认选中
        setStoreVar(defaultTreeData);
      }
    });
  };

  const treeItemClick = (item) => {
    if (active.value == item['nodeId']) {
      active.value = '';
      setStoreVar({});
    }
    let a = setTimeout(() => {
      active.value = item['nodeId'];
      setStoreVar(item);
      clearTimeout(a);
    }, 0);
  };

  getTreesData();
</script>

<style lang="less" scoped>
  .side_bar {
    background-color: var(--bg-color);
    min-height: 1100px;
    width: 280px;
  }
  .tabs {
    display: flex;
    height: 47px;
    border-bottom: 1px solid #e9e9e9;
    .tabs-items {
      flex: 1;
      color: #666;
      cursor: pointer;
      font-size: var(--base-font-size);
      text-align: center;
      user-select: none;
      span {
        display: inline-block;
        position: relative;
        line-height: 46px;
        &::after {
          position: absolute;
          content: '';
          bottom: -1px;
          width: 0;
          left: 50%;
          height: 2px;
          transition: all 0.2s;
        }
      }
      &.active {
        color: var(--light-color);
        span::after {
          left: 0;
          width: 100%;
          background-color: var(--light-color);
        }
      }
    }
  }
  .menu_box {
    padding-top: 10px;
    :deep(.el-tabs__header) {
      display: none;
    }
  }
</style>